import { useCallback, useState } from "react";
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from "../constants/pagination";

export const useHandlePagination = (
  defaultPageSize = DEFAULT_PAGE_SIZE,
  defaultCurrentPage = 1,
  options = DEFAULT_PAGE_SIZE_OPTIONS,
) => {
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [currentPage, setCurrentPage] = useState(defaultCurrentPage);
  const [offset, setOffset] = useState(0);

  const pageSizeOptions =
    options !== DEFAULT_PAGE_SIZE_OPTIONS ? Array.from(new Set([...options, defaultPageSize])).sort((a, b) => a - b) : options;

  const handlePaginationChange = useCallback(
    (current: number, size: number) => {
      const pageSizeChanged = size !== pageSize;

      const newPageSize = size || pageSize;
      const newCurrentPage = pageSizeChanged ? 1 : current;
      const newOffset = pageSizeChanged ? 0 : (newCurrentPage - 1) * newPageSize;

      setOffset(newOffset);
      setCurrentPage(newCurrentPage);
      setPageSize(newPageSize);
    },
    [pageSize, currentPage],
  );

  const resetPagination = useCallback(() => {
    setOffset(0);
    setCurrentPage(1);
  }, []);

  return { pageSize, handlePaginationChange, currentPage, offset, pageSizeOptions, resetPagination };
};
